export enum StatusEnum {
    INSTALLATION = 'INSTALLATION',
    OPERATION = 'OPERATION',
    REJECTED = 'REJECTED',
    VALIDATION = 'VALIDATION',
    WAIT_FOR_SIGNATURE = 'WAIT_FOR_SIGNATURE',
}

